import { ThemeModeComponentSwitcher } from '@apps-common/components/common/ThemeModeComponentSwitcher'

interface IProps {
  containerClasses?: string
  classes?: string
}

export const MyMonitoringLogoOnlyColor: React.FC<IProps> = ({ containerClasses, classes }) => (
  <div className={containerClasses}>
    <ThemeModeComponentSwitcher
      lightComponent={<img src='/assets/logos/mymon_dark_logo_only.png' alt='MyMonitoring Logo' className={classes} />}
      darkComponent={<img src='/assets/logos/mymon_light_logo_only.png' alt='MyMonitoring Logo' className={classes} />}
    />
  </div>
)
